import classNames from 'classnames';
import styles from './Footer.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import PentiaLogo from 'ui/icons/pentia_name_logo.svg';
import KpLogo from 'ui/icons/klausenpartners_logo.svg';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { UI_OfficeCard, UI_OfficeProps } from 'ui/components/2-molecules/Card/OfficeCard/OfficeCard';
import { UI_ContactCard } from 'ui/components/2-molecules/Card/ContactCard/ContactCard';
import { UI_Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';
import { UI_Container } from '../Container/Container';

export interface UI_FooterProps {
	className?: string;
	heading?: string;
	office?: Array<UI_OfficeProps>;
	ctaLink?: {
		url: string;
		target?: string;
		name?: string;
	};
	ctaLinkLabel?: string;
	cvrNumber?: string;
	some?: Array<UI_SomeProps>;
	goToLinkLabel?: string;
	policies?: {
		url: string;
		target?: string;
		name?: string;
	};
	contact?: {
		telephone?: string;
		email?: string;
		heading?: string;
	};
	globalTheme?: string;
	dictionary?: { [key: string]: string };
	children?: React.ReactNode;
}

export interface UI_SomeProps {
	url: string;
	target?: string;
	name?: string;
}

export const UI_Footer: React.FC<UI_FooterProps> = ({
	className,
	heading,
	office,
	ctaLink,
	globalTheme,
	dictionary,
	ctaLinkLabel,
	cvrNumber,
	some,
	goToLinkLabel,
	policies,
	contact,
	children,
}) => {
	return (
		<footer className={classNames(styles.Footer, className)} role="contentinfo">
			<UI_Container width="Standard">
				<div className={classNames(styles.Footer_topSection, className)}>
					{globalTheme !== 'kogp' && (
						<div className={classNames(styles.Footer_topSectionText, className)}>
							{heading && (
								<UI_Heading headingLevel="h2" style="sm" className={styles.Footer_heading}>
									{heading}
								</UI_Heading>
							)}
							{ctaLink && (
								<UI_Link href={ctaLink.url} target={ctaLink.target} title={ctaLinkLabel}>
									{ctaLink.name}
								</UI_Link>
							)}
						</div>
					)}
				</div>
				<div className={styles.Footer_details}>
					{(globalTheme === 'pentia-dk' || globalTheme === 'pentia-se' || !globalTheme) && (
						<UI_Icon size="2xl" className={styles.Footer_logo}>
							<PentiaLogo />
						</UI_Icon>
					)}
					{globalTheme === 'kogp' && (
						<div className={styles.Footer_identity}>
							<UI_Icon size="auto" className={styles.Footer_logo}>
								<KpLogo />
							</UI_Icon>
							<UI_Heading headingLevel="h2" style="xl" className={styles.Footer_heading}>
								Creating
								<br />
								Commercial
								<br />
								Edge
							</UI_Heading>
						</div>
					)}
					<div className={styles.Footer_information}>
						{office?.map((office, index) => (
							<UI_OfficeCard
								className={styles.Footer_officeCard}
								key={index}
								heading={office.heading}
								address={office.address}
								zipcode={office.zipcode}
							/>
						))}
						{(globalTheme === 'pentia-dk' || globalTheme === 'pentia-se' || !globalTheme) && (
							<>
								<UI_ContactCard
									className={styles.Footer_contactCard}
									telephone={contact?.telephone}
									email={contact?.email}
									heading={contact?.heading}
								></UI_ContactCard>
								<div className={styles.Footer_extraInformation}>
									<UI_Paragraph>{cvrNumber}</UI_Paragraph>
									{some?.map((some, index) => (
										<UI_Link key={index} href={some?.url} title={goToLinkLabel + ' ' + some.name}>
											{some?.name}
										</UI_Link>
									))}
									<UI_Link href={policies?.url} title={goToLinkLabel + ' ' + policies?.name}>
										{policies?.name}
									</UI_Link>
								</div>
							</>
						)}
						{globalTheme === 'kogp' && (
							<>
								<div>
									<UI_Heading headingLevel="h3" className={styles.OfficeCard_heading}>
										{dictionary?.ContactTitle}
									</UI_Heading>
									<UI_ContactCard
										className={styles.Footer_contactCard}
										telephone={contact?.telephone}
										email={contact?.email}
										heading={contact?.heading}
									></UI_ContactCard>
								</div>
								{some && (
									<div className={styles.Footer_extraInformation}>
										<UI_Heading headingLevel="h3" className={styles.OfficeCard_heading}>
											{dictionary?.FollowUs}
										</UI_Heading>
										{some?.map((some, index) => (
											<UI_Link key={index} href={some?.url} title={goToLinkLabel + ' ' + some.name}>
												{some?.name}
											</UI_Link>
										))}
									</div>
								)}
								<div>
									<UI_Heading headingLevel="h3" className={styles.OfficeCard_heading}>
										{dictionary?.CVR}
									</UI_Heading>
									<UI_Paragraph>{cvrNumber}</UI_Paragraph>
								</div>
								<div>
									<UI_Heading headingLevel="h3" className={styles.OfficeCard_heading}>
										{dictionary?.Legal}
									</UI_Heading>
									<UI_Link href={policies?.url} title={policies?.name}>
										{policies?.name}
									</UI_Link>
								</div>
							</>
						)}
					</div>
				</div>
			</UI_Container>
		</footer>
	);
};
